import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { DependencyTracker2tg9lout2xnpn as DependencyTracker } from './DependencyTracker.mjs';
import {
  get6d5x931vk0s as get,
  fold36i9psb7d5v48 as fold,
  minusKeyyqanvso9aovh as minusKey,
  plusolev77jfy5r9 as plus,
  Element2gr7ezmxqaln7 as Element,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/CoroutineContext.mjs';
import {
  protoOf180f3jzyo7rfj as protoOf,
  equals2au1ep9vhcato as equals,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  _ReactiveState___get_raw__impl__92ipya3q1gard26whe6 as _ReactiveState___get_raw__impl__92ipya,
  InternalReactiveNotActive_instanceavp2nits8goa as InternalReactiveNotActive_instance,
  InternalReactiveNotReady_instancer79hznuwejmn as InternalReactiveNotReady_instance,
  ReactiveState__get_impl_reoidrydwo1sb45wj0 as ReactiveState__get_impl_reoidr,
  InternalReactiveWrapper6qytbrc1rcqv as InternalReactiveWrapper,
  InternalReactiveThrownException1wn4fe03qbefg as InternalReactiveThrownException,
} from '../core/ReactiveState.mjs';
import { intercepted2ogpsikxxj4u0 as intercepted } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { CancellableContinuationImpl1cx201opicavg as CancellableContinuationImpl } from '../../../../../kotlinx-coroutines-core/kotlinx/coroutines/CancellableContinuationImpl.mjs';
import { addAndRunListener8g331b1wn43q as addAndRunListener } from '../core/coreInterfaces.mjs';
import {
  Companion_instancejy2056q2ma5w as Companion_instance,
  _Result___init__impl__xyqfz832zdzqrocazzs as _Result___init__impl__xyqfz8,
  createFailure8paxfkfa5dc7 as createFailure,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/Result.mjs';
import { CancellationException3b36o9qz53rgr as CancellationException } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/cancellation/CancellationException.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var KeyClass;
function Key() {
  if (KeyClass === VOID) {
    class $ {}
    initMetadataForObject($, 'Key');
    KeyClass = $;
  }
  return KeyClass;
}
var Key_instance;
function Key_getInstance() {
  return Key_instance;
}
var DependencyChangeListenerClass;
function DependencyChangeListener() {
  if (DependencyChangeListenerClass === VOID) {
    class $ extends DependencyTracker() {
      get_key_18j28a_k$() {
        return Key_instance;
      }
      onDependencyNotReady_ntxysq_k$() {
        return this.onDependencyChange_yaqozu_k$();
      }
    }
    protoOf($).get_y2st91_k$ = get;
    protoOf($).fold_j2vaxd_k$ = fold;
    protoOf($).minusKey_9i5ggf_k$ = minusKey;
    protoOf($).plus_s13ygv_k$ = plus;
    initMetadataForClass($, 'DependencyChangeListener', VOID, VOID, [Element()]);
    DependencyChangeListenerClass = $;
  }
  return DependencyChangeListenerClass;
}
function *rerunOn(listenable, $completion) {
  // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp0_safe_receiver = $completion.get_context_h02k06_k$().get_y2st91_k$(Key_instance);
  if (tmp0_safe_receiver == null)
    null;
  else {
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver;
    if (it.existingDependency_tkmz95_k$(listenable) == null) {
      it.registerDependency_23xa5k_k$(listenable, listenable.addListener_6y9mct_k$(() => {
        it.onDependencyChange_yaqozu_k$();
        return Unit_instance;
      }));
    }
  }
  return Unit_instance;
}
function *awaitOnce(_this__u8e3s4, $completion) {
  var state = _this__u8e3s4.get_state_wc71uu_k$();
  var tmp;
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
  var tmp_0;
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
  if (!equals(_ReactiveState___get_raw__impl__92ipya(state), InternalReactiveNotActive_instance)) {
    tmp_0 = !equals(_ReactiveState___get_raw__impl__92ipya(state), InternalReactiveNotReady_instance);
  } else {
    tmp_0 = false;
  }
  if (tmp_0) {
    tmp = ReactiveState__get_impl_reoidr(state);
  } else {
    // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
    // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
    tmp = yield () => {
      var uCont = $completion;
      var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
      cancellable.initCancellability_shqc60_k$();
      var it = cancellable;
      var remover = {_v: null};
      var alreadyRun = {_v: false};
      var done = {_v: false};
      remover._v = addAndRunListener(_this__u8e3s4, () => {
        var state = _this__u8e3s4.get_state_wc71uu_k$();
        var tmp;
        var tmp_0;
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.ready' call
        var tmp_1;
        // Inline function 'com.lightningkite.reactive.core.ReactiveState.active' call
        if (!equals(_ReactiveState___get_raw__impl__92ipya(state), InternalReactiveNotActive_instance)) {
          tmp_1 = !equals(_ReactiveState___get_raw__impl__92ipya(state), InternalReactiveNotReady_instance);
        } else {
          tmp_1 = false;
        }
        if (tmp_1) {
          tmp_0 = !done._v;
        } else {
          tmp_0 = false;
        }
        if (tmp_0) {
          done._v = true;
          resumeState(it, state);
          var tmp0_safe_receiver = remover._v;
          var tmp1_elvis_lhs = tmp0_safe_receiver == null ? null : tmp0_safe_receiver();
          var tmp_2;
          if (tmp1_elvis_lhs == null) {
            // Inline function 'kotlin.run' call
            alreadyRun._v = true;
            tmp_2 = Unit_instance;
          } else {
            tmp_2 = tmp1_elvis_lhs;
          }
          tmp = tmp_2;
        }
        return Unit_instance;
      });
      if (alreadyRun._v)
        remover._v();
      it.invokeOnCancellation_kffkqp_k$((it) => {
        remover._v();
        return Unit_instance;
      });
      return cancellable.getResult_fck196_k$();
    };
  }
  return tmp;
}
function *await_0(_this__u8e3s4, $completion) {
  // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp0_safe_receiver = $completion.get_context_h02k06_k$().get_y2st91_k$(Key_instance);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var tmp$ret$3;
    $l$block_2: {
      var it = tmp0_safe_receiver;
      var cont = {_v: null};
      if (it.existingDependency_tkmz95_k$(_this__u8e3s4) == null) {
        it.registerDependency_23xa5k_k$(_this__u8e3s4, _this__u8e3s4.addListener_6y9mct_k$(() => {
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
          // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
          var this_0 = _this__u8e3s4.get_state_wc71uu_k$();
          var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
          var tmp;
          if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
            if (cont._v == null) {
              it.onDependencyNotReady_ntxysq_k$();
            }
            tmp = Unit_instance;
          } else {
            if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
              if (cont._v == null) {
                it.onDependencyNotReady_ntxysq_k$();
              }
              tmp = Unit_instance;
            } else {
              if (tmp0_subject instanceof InternalReactiveThrownException()) {
                var r = _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
                var tmp0_safe_receiver = cont._v;
                var tmp_0;
                if (tmp0_safe_receiver == null) {
                  tmp_0 = null;
                } else {
                  // Inline function 'kotlin.let' call
                  // Inline function 'kotlin.coroutines.resumeWithException' call
                  // Inline function 'kotlin.Companion.failure' call
                  var tmp$ret$12 = _Result___init__impl__xyqfz8(createFailure(r));
                  tmp0_safe_receiver.resumeWith_rk9gbt_k$(tmp$ret$12);
                  cont._v = null;
                  tmp_0 = Unit_instance;
                }
                if (tmp_0 == null) {
                  it.onDependencyChange_yaqozu_k$();
                }
                tmp = Unit_instance;
              } else {
                if (tmp0_subject instanceof InternalReactiveWrapper()) {
                  var r_0 = _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
                  var tmp0_safe_receiver_0 = cont._v;
                  var tmp_1;
                  if (tmp0_safe_receiver_0 == null) {
                    tmp_1 = null;
                  } else {
                    // Inline function 'kotlin.let' call
                    // Inline function 'kotlin.coroutines.resume' call
                    // Inline function 'kotlin.Companion.success' call
                    var tmp$ret$17 = _Result___init__impl__xyqfz8(r_0);
                    tmp0_safe_receiver_0.resumeWith_rk9gbt_k$(tmp$ret$17);
                    cont._v = null;
                    tmp_1 = Unit_instance;
                  }
                  if (tmp_1 == null) {
                    it.onDependencyChange_yaqozu_k$();
                  }
                  tmp = Unit_instance;
                } else {
                  var r_1 = _ReactiveState___get_raw__impl__92ipya(this_0);
                  var tmp0_safe_receiver_1 = cont._v;
                  var tmp_2;
                  if (tmp0_safe_receiver_1 == null) {
                    tmp_2 = null;
                  } else {
                    // Inline function 'kotlin.let' call
                    // Inline function 'kotlin.coroutines.resume' call
                    // Inline function 'kotlin.Companion.success' call
                    var tmp$ret$22 = _Result___init__impl__xyqfz8(r_1);
                    tmp0_safe_receiver_1.resumeWith_rk9gbt_k$(tmp$ret$22);
                    cont._v = null;
                    tmp_2 = Unit_instance;
                  }
                  if (tmp_2 == null) {
                    it.onDependencyChange_yaqozu_k$();
                  }
                  tmp = Unit_instance;
                }
              }
            }
          }
          return Unit_instance;
        }));
      }
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
      // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
      var this_0 = _this__u8e3s4.get_state_wc71uu_k$();
      var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(this_0);
      var tmp_0;
      if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
        // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
        // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
        tmp$ret$3 = yield () => {
          var uCont = $completion;
          var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
          cancellable.initCancellability_shqc60_k$();
          cont._v = cancellable;
          return cancellable.getResult_fck196_k$();
        };
        break $l$block_2;
      } else {
        if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
          // Inline function 'kotlinx.coroutines.suspendCancellableCoroutine' call
          // Inline function 'kotlin.js.suspendCoroutineUninterceptedOrReturnJS' call
          tmp$ret$3 = yield () => {
            var uCont = $completion;
            var cancellable = new (CancellableContinuationImpl())(intercepted(uCont), 1);
            cancellable.initCancellability_shqc60_k$();
            cont._v = cancellable;
            return cancellable.getResult_fck196_k$();
          };
          break $l$block_2;
        } else {
          if (tmp0_subject instanceof InternalReactiveThrownException()) {
            throw _ReactiveState___get_raw__impl__92ipya(this_0).exception_1;
          } else {
            if (tmp0_subject instanceof InternalReactiveWrapper()) {
              tmp$ret$3 = _ReactiveState___get_raw__impl__92ipya(this_0).other_1;
              break $l$block_2;
            } else {
              tmp$ret$3 = _ReactiveState___get_raw__impl__92ipya(this_0);
              break $l$block_2;
            }
          }
        }
      }
    }
    tmp = tmp$ret$3;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? (yield* /*#__NOINLINE__*/awaitOnce(_this__u8e3s4, $completion)) : tmp1_elvis_lhs;
}
function resumeState(_this__u8e3s4, state) {
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  // Inline function 'com.lightningkite.reactive.core.ReactiveState.handle' call
  var tmp0_subject = _ReactiveState___get_raw__impl__92ipya(state);
  var tmp;
  if (equals(tmp0_subject, InternalReactiveNotReady_instance)) {
    // Inline function 'kotlin.coroutines.resumeWithException' call
    // Inline function 'kotlin.Companion.failure' call
    var exception = CancellationException().new_kotlin_coroutines_cancellation_CancellationException_kxgi4u_k$('State not ready');
    var tmp$ret$4 = _Result___init__impl__xyqfz8(createFailure(exception));
    _this__u8e3s4.resumeWith_rk9gbt_k$(tmp$ret$4);
    tmp = Unit_instance;
  } else {
    if (equals(tmp0_subject, InternalReactiveNotActive_instance)) {
      // Inline function 'kotlin.coroutines.resumeWithException' call
      // Inline function 'kotlin.Companion.failure' call
      var exception_0 = CancellationException().new_kotlin_coroutines_cancellation_CancellationException_kxgi4u_k$('State not ready');
      var tmp$ret$7 = _Result___init__impl__xyqfz8(createFailure(exception_0));
      _this__u8e3s4.resumeWith_rk9gbt_k$(tmp$ret$7);
      tmp = Unit_instance;
    } else {
      if (tmp0_subject instanceof InternalReactiveThrownException()) {
        // Inline function 'kotlin.coroutines.resumeWithException' call
        // Inline function 'kotlin.Companion.failure' call
        var exception_1 = _ReactiveState___get_raw__impl__92ipya(state).exception_1;
        var tmp$ret$10 = _Result___init__impl__xyqfz8(createFailure(exception_1));
        _this__u8e3s4.resumeWith_rk9gbt_k$(tmp$ret$10);
        tmp = Unit_instance;
      } else {
        if (tmp0_subject instanceof InternalReactiveWrapper()) {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value = _ReactiveState___get_raw__impl__92ipya(state).other_1;
          var tmp$ret$13 = _Result___init__impl__xyqfz8(value);
          _this__u8e3s4.resumeWith_rk9gbt_k$(tmp$ret$13);
          tmp = Unit_instance;
        } else {
          // Inline function 'kotlin.coroutines.resume' call
          // Inline function 'kotlin.Companion.success' call
          var value_0 = _ReactiveState___get_raw__impl__92ipya(state);
          var tmp$ret$16 = _Result___init__impl__xyqfz8(value_0);
          _this__u8e3s4.resumeWith_rk9gbt_k$(tmp$ret$16);
          tmp = Unit_instance;
        }
      }
    }
  }
}
function *await_1(_this__u8e3s4, $completion) {
  // Inline function 'kotlinx.coroutines.currentCoroutineContext' call
  // Inline function 'kotlin.js.getCoroutineContext' call
  var tmp0_safe_receiver = $completion.get_context_h02k06_k$().get_y2st91_k$(Key_instance);
  var tmp;
  if (tmp0_safe_receiver == null) {
    tmp = null;
  } else {
    // Inline function 'kotlin.let' call
    var it = tmp0_safe_receiver;
    var last = {_v: _this__u8e3s4.get_value_j01efc_k$()};
    if (it.existingDependency_tkmz95_k$(_this__u8e3s4) == null) {
      it.registerDependency_23xa5k_k$(_this__u8e3s4, _this__u8e3s4.addListener_6y9mct_k$(() => {
        var newVal = _this__u8e3s4.get_value_j01efc_k$();
        var tmp;
        if (!equals(last._v, newVal)) {
          last._v = newVal;
          it.onDependencyChange_yaqozu_k$();
          tmp = Unit_instance;
        }
        return Unit_instance;
      }));
      last._v = _this__u8e3s4.get_value_j01efc_k$();
    }
    tmp = last._v;
  }
  var tmp1_elvis_lhs = tmp;
  return tmp1_elvis_lhs == null ? _this__u8e3s4.get_value_j01efc_k$() : tmp1_elvis_lhs;
}
//region block: init
Key_instance = new (Key())();
//endregion
//region block: exports
export {
  DependencyChangeListener as DependencyChangeListener1518w8dt8yuu7,
  Key_instance as Key_instance2oomvptbmjvj0,
  awaitOnce as awaitOnce3bs0u39jtmrli,
  await_1 as await1xlt6i5aa076q,
  await_0 as await1uwe8zvsjq69o,
  rerunOn as rerunOn3zthnxaue6ps,
};
//endregion

//# sourceMappingURL=DependencyChangeListener.mjs.map
